/** Enforcing theme tokens to be used for default */
const themeTokens = {
    primaryColor: 'var(--ant-primary-color)',
    hoveredPrimaryColor: 'var(--ant-primary-color-hover)',
    textColor: '#fff',

    baseFontSize: '0.875rem',
    buttonFontSize: '0.875rem',
    inputFontSize: '0.875rem',

    inputFieldHeight: '32px',
};

export default themeTokens;
